/* axios 基礎與封裝管理 API
 * https://ithelp.ithome.com.tw/articles/10304656
 */
import { ElMessage, ElLoading } from 'element-plus'
import axios from "axios";

//創建實例
const API = axios.create({
    baseURL: process.env.BASE_URL,
    headers: {
        "Content-Type": "application/json; charset=utf-8",
        Accept: "application/json",
    },
});

//request 攔截器
API.interceptors.request.use(function (config) {
    // 在送出 request 之前可以在這裡攔截處理
    // 可以放 token
    let token = localStorage.getItem("Token")//取得token
    config.headers.Authorization = "Bearer " + token;
    //config.headers["Content-Type"] = 'application/json';
    return config;
}, function (error) {
    // 如果 request 出現 error
    // 可以在這裡攔截處理
    return Promise.reject(error);
});

//response 攔截器
API.interceptors.response.use(function (response) {
    // 回傳的 status code 在 2xx 區間會觸發這個函式
    // 可以在這裡拿到 response 做處理 
    return response;
}, function (error) {
    if (error.response) {
        console.log(error.response.status, error.message);
        switch (error.response.status) {
            //可以在這裡針對不同 status code 做處理
            case 401:
                ElMessage.error('登入逾時，請重新登入!');
                console.log(error.message);
                break;
            case 404:
                ElMessage.error('功能不存在!');
                console.log(error.message);
                break;
            case 500:
                ElMessage.error('程式發生問題!');
                console.log(error.message);
                break;
            default:
                ElMessage.error('執行失敗!');
                console.log(error);
        }
    }
    if (!window.navigator.onLine) {
        ElMessage.error('請重新連線後重整網頁!');
        return;
    }
    return Promise.reject(error);
});

const options = { lock: true, text: 'Loading' }

export default {
    async GET(url, params) {
        try {
            const res = await API.get(url, {
                params,
            });
            return res.data;
        } catch (res) {
            return Promise.reject(res.message);
        }
    },
    async DELETE(url, params) {
        try {
            const res = await API.delete(url, {
                params,
            });
            return res.data;
        } catch (res) {
            return Promise.reject(res.message);
        }
    },
    async POST(...arg) {
        try {
            const res = await API.post(...arg);
            return res.data;
        } catch (res) {
            return Promise.reject(res.message);
        }
    },
    async UPLOAD(...arg) {
        let loading = ElLoading.service(options);
        try {
            API.defaults.headers["Content-Type"] = 'multipart/form-data';
            const res = await API.post(...arg);
            return res.data;
        } catch (res) {
            return Promise.reject(res.message);
        } finally {
            loading.close();
        }
    }
};

